import { LocationOnOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import React from "react";
import { MY_PLACE_CARD_SIZE } from "../../constants/configs";
import { useTranslation } from "react-i18next";

type TOwnProps = {
  onEnableLocation: () => void;
  disabled?: boolean;
};

const PrimerCard = (props: TOwnProps) => {
  const { t } = useTranslation("component");
  const { onEnableLocation, disabled } = props;

  return (
    <Card
      sx={(theme) => ({
        margin: "0 auto",
        padding: theme.spacing(1),
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(3),
      })}
      data-testid="enable-location-primer"
    >
      <Typography gutterBottom variant="h5" component="h2" align="center">
        {t("myPlace.primerCard.allowLocationAccess")}
      </Typography>

      <CardMedia
        component="img"
        image="/assets/icons/MyPlace.svg"
        title="My Place"
        alt="My Place"
        sx={(theme) => ({
          width: MY_PLACE_CARD_SIZE,
          height: MY_PLACE_CARD_SIZE,
          borderRadius: 12,
          margin: "0 auto",
          marginTop: theme.spacing(3),
          marginBottom: theme.spacing(3),
        })}
      />

      <CardContent>
        <Typography
          variant="body2"
          color="textPrimary"
          component="p"
          align="center"
          sx={(theme) => ({
            fontSize: "1.2em",
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
          })}
        >
          {t("myPlace.primerCard.hint")}
        </Typography>
      </CardContent>

      <CardActions>
        <Button
          size="small"
          color="primary"
          endIcon={<LocationOnOutlined />}
          onClick={onEnableLocation}
          disabled={disabled}
          data-testid="enable-location-button"
          sx={(theme) => ({
            margin: "0 auto",
            backgroundColor: "#8ec53f",
            borderRadius: 40,
            padding: theme.spacing(1),
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            color: "white",
            "&:hover": {
              backgroundColor: "black",
            },
            "&.Mui-disabled": {
              backgroundColor: "#e0e0e0!important",
            },
          })}
        >
          {t("myPlace.primerCard.enableLocation")}
        </Button>
      </CardActions>
    </Card>
  );
};

export default PrimerCard;
